export default function AppIcon() {
	return (
		<div className='font-medium self-center py-4 text-xl sm:text-2xl uppercase text-blue-600'>
			<img src='/AltiaIDlogo.png' className='h-20' />
		</div>
	);
}
